const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** 기다린 시간을 한 단위로만 말한다 — "방금", "25분", "5시간", "3일". 미래 시각은 "방금". */
export const formatElapsed = (since: string | Date, now: Date): string => {
  const elapsed = now.getTime() - new Date(since).getTime();
  if (elapsed < MINUTE) return '방금';
  if (elapsed < HOUR) return `${Math.floor(elapsed / MINUTE)}분`;
  if (elapsed < DAY) return `${Math.floor(elapsed / HOUR)}시간`;
  return `${Math.floor(elapsed / DAY)}일`;
};
